import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a53e7d70"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-page-number-4',
  props: {
    isDetail: { type: Boolean, default: false },
    pageNo: { default: '01' }
  },
  setup(__props: any) {

const props = __props;

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 62 60">
    <g id="yema4" transform="translate(-962 -4)">
      <rect id="矩形_2898" data-name="矩形 2898" width="55" height="55" transform="translate(969 9)" fill="var(--theme-color-1)"/>
      <g id="矩形_2897" data-name="矩形 2897" transform="translate(962 4)" fill="#fff" stroke="var(--theme-color-1)" stroke-width="3">
        <rect width="55" height="55" stroke="none"/>
        <rect x="1.5" y="1.5" width="52" height="52" fill="none"/>
      </g>
      <text id="_01" data-name="01" transform="translate(974 43)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["svg-block", !_ctx.isDetail && 'isDetail']),
    innerHTML: svg.value
  }, null, 10, _hoisted_1))
}
}

})